module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQoNCiA8Zz4NCiAgPHRpdGxlPmJhY2tncm91bmQ8L3RpdGxlPg0KICA8cmVjdCBmaWxsPSJub25lIiBpZD0iY2FudmFzX2JhY2tncm91bmQiIGhlaWdodD0iNDAyIiB3aWR0aD0iNTgyIiB5PSItMSIgeD0iLTEiLz4NCiA8L2c+DQogPGc+DQogIDx0aXRsZT5MYXllciAxPC90aXRsZT4NCiAgPHBhdGggZmlsbD0iIzVkYTFhYiIgaWQ9InN2Z18xIiBkPSJtMTYsMGExNiwxNiAwIDAgMSAwLDMyYTE2LDE2IDAgMCAxIDAsLTMybTMsMTVsLTYsMGwwLDExbDYsMGwwLC0xMXptLTMsLTlhMywzIDAgMCAwIDAsNmEzLDMgMCAwIDAgMCwtNiIvPg0KIDwvZz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-icon.svg
// module id = 719
// module chunks = 1